<template>
  <div class="videoView">
    <!-- style="object-fit: fill" -->
    <video
      v-if="loginTrue"
      class="video-source"
      height="300px"
      width="100%"
      controls
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsinline="true"
      x5-video-player-type="h5-page"
      x5-video-orientation="h5"
      x5-video-player-fullscreen="true"
      preload="auto"
      :poster="playImg"
    >
      <source :src="playSrc" type="video/mp4" />
    </video>
    <h2 v-if="loginTrue" v-html="playName"></h2>
    <div class="back" v-if="isAndroid && loginTrue" @click="backHome">返回</div>
    <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    />
  </div>
</template>

<script>
import Login from "./Integrated/components/login.vue";
import ChoiceCompany from "./Integrated/components/choiceCompany.vue";
export default {
  components: {
    Login,
    ChoiceCompany,
  },
  name: "VideoView",
  data() {
    return {
      playSrc: "",
      playName: "",
      playImg: "",
      isAndroid: false,
      loginTk: false,
      mobile: "",
      companyList: [],
      choiceTk: false,
      share: false,
      loginTrue:true
    };
  },
  created() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.playSrc = this.$route.query.playSrc;
    this.playName = this.$route.query.playName;
    this.playImg = this.$route.query.playImg ? this.$route.query.playImg : "";
    if(this.$route.query.app_secret){
      sessionStorage.setItem("app_secret", this.$route.query.app_secret)
      localStorage.setItem("userInfo", this.$route.query.userInfo)
      this.isAndroid = false
      
    }
  },
  mounted() {

    if(sessionStorage.getItem("loginTk") && sessionStorage.getItem("loginMsg")){
      this.loginTk = sessionStorage.getItem("loginTk")
    }
    // 可能有点滴灵犀报告查看视频再做处理
    if (
      !localStorage.getItem("IntegratedTitle") ||
      !localStorage.getItem("userInfo")
    ) {
      localStorage.setItem("IntegratedTitle", this.$route.query.from);
      this.loginTk = true;
      this.share = true;
      this.loginTrue = false
    } else {
      this.getList();
    }
    if(this.$route.query.app_secret){
      this.getList()
    }
    document.title = this.$route.query.from
      ? this.$route.query.from
      : localStorage.getItem("IntegratedTitle");
  },
  methods: {
    tabCompany(companyList, phone) {
      this.mobile = phone;
      this.companyList = companyList;
      this.choiceTk = true;
    },
    getList() {
      this.loginTk = false;
      this.choiceTk = false
      this.loginTrue = true
    },
    backHome() {
      if (this.share) {
        this.$router.push({
          path: "/IntegratedHome?title=" + this.$route.query.from,
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.videoView {
  max-width: 750px;
  margin: 0 auto;
}
h2 {
  font-size: 0.4rem;
  padding: 0 0.3rem 1rem;
  margin: 0;
}
.back {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  background: #f7f7f7;
  line-height: 0.8rem;
  font-size: 0.32rem;
  text-align: center;
}
</style>
